import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { NotificationDot } from './types';

/**
 * Retrieves Gamification notification dot data for user
 *
 * @method getNotificationDotStatus
 * @memberof Gamification
 * @returns {Promise<NotificationDot>} - Properties for NotificationDot component
 */

export const getNotificationDotStatus = async (): Promise<NotificationDot> => {
  const url = `${Constants.BACKEND_URL}/get-unread-notifications`;

  return httpGet(url, {}).then((response) => {
    if (response && response.data) {
      const notificationCount = response.data.unread_notifications.length;
      if (notificationCount > 0) {
        return { on: true, count: notificationCount };
      } else {
        return { on: false };
      }
    }
    return { on: false };
  });
};
